(() => {
  const panel = document.querySelector('[data-kd-consent]');
  if (!panel) return;
  const status = panel.querySelector('[data-consent-status]');
  let privacy;
  let returnFocus;
  const sync = () => {
    const consent = privacy?.currentVisitorConsent() || {};
    panel.querySelectorAll('[data-consent-category]').forEach(input => {
      input.checked = consent[input.dataset.consentCategory] === 'yes';
    });
    return consent;
  };
  const open = () => {
    returnFocus = document.activeElement;
    sync(); panel.hidden = false;
    panel.querySelector('summary').focus();
  };
  document.querySelectorAll('[data-kd-consent-open]').forEach(button => button.addEventListener('click', open));
  panel.querySelectorAll('[data-consent-action]').forEach(button => button.addEventListener('click', () => {
    if (!privacy) { status.textContent = panel.dataset.unavailable; return; }
    const action = button.dataset.consentAction;
    const consent = {};
    panel.querySelectorAll('[data-consent-category]').forEach(input => {
      consent[input.dataset.consentCategory] = action === 'save' ? input.checked : action === 'accept';
    });
    panel.querySelectorAll('button').forEach(item => { item.disabled = true; });
    status.textContent = panel.dataset.saving;
    let finished = false;
    const fail = () => {
      if (finished) return;
      finished = true;
      status.textContent = panel.dataset.error;
      panel.querySelectorAll('button').forEach(item => { item.disabled = false; });
    };
    const timeout = setTimeout(fail, 8000);
    try {
      privacy.setTrackingConsent(consent, () => {
        if (finished) return;
        clearTimeout(timeout);
        // This callback may run after setTrackingConsent returned, outside its
        // surrounding try/catch. A provider readback failure must unlock retry.
        let saved;
        try { saved = privacy.currentVisitorConsent(); }
        catch { fail(); return; }
        if (!saved || !Object.keys(consent).every(key => saved[key] === (consent[key] ? 'yes' : 'no'))) { fail(); return; }
        finished = true;
        panel.hidden = true; status.textContent = '';
        panel.querySelectorAll('button').forEach(item => { item.disabled = false; });
        if (returnFocus?.isConnected) returnFocus.focus();
      });
    } catch { clearTimeout(timeout); fail(); }
  }));
  const ready = () => {
    privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;
    const consent = sync();
    if (['analytics', 'marketing', 'preferences'].some(key => !consent[key])) panel.hidden = false;
  };
  if (window.Shopify?.customerPrivacy) ready();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) ready(); });
})();
